const info = (message: string): void => {
   global.alert(message);
};

const warn = (message: string): void => {
   global.alert(message);
};

export default {
   info,
   warn
};